<template>
    <div>
        <nav-breadcrumb :menu="[{label: '详情'}]"/>
        <panel  label="基本信息">
            <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                    <el-col :span="24" >
                        <el-form-item label="用印类型：" prop="t__applicationTypeCode" >
                            {{dataForm.t__applicationTypeCode|Status2CN}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="用印日期：" prop="t__applicationDate" >
                            {{dataForm.t__applicationDate|moment('YYYY-MM-DD')}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="所需盖章：" prop="t__companySeal" >
                            <el-checkbox  v-model="dataForm.t__companySeal" true-label="Y" false-label="N" disabled>公章</el-checkbox>
                            <el-checkbox  v-model="dataForm.t__legalRepSeal" true-label="Y" false-label="N" disabled>法人章</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="用印描述：" style="width: 60%">
                            <el-input type="textarea" v-model="dataForm.t__remarks" style="margin-bottom:10px;" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </panel>
        <panel  label="关联信息">
            <panel v-for="(item,idx) in dataForm.detail"
                   :key="idx" style="border:solid 1px #ddd">
                <panel  label="贷款信息" >
                    <el-form :model="item" label-width="170px" class="xzformitemmb" ref="dataForm1" >
                        <el-row>
                            <panel border>
                                <el-col :span="12">
                                    <el-form-item label="贷款编号 ：">
                                        {{item.fi__transactionNo}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款状态：">
                                        {{(item.fi__transactionStatus?('Financing_'+ item.fi__transactionStatus):'')|Status2CN}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="客户名称：">
                                        {{item.fi__customerName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="渠道商：">
                                        {{item.d__dealerName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款金额：">
                                        {{item.fi__totalAmount|formatMoney}} 元
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="贷款产品：">
                                        {{item.ct__productName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款开始日期：">
                                        {{item.fi__startDate|moment('YYYY-MM-DD')}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款结束日期：">
                                        {{item.fi__endDate|moment('YYYY-MM-DD')}}
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="贷款合同利率：">
                                        {{item.fi__interestRate}}% （{{item.fi__interestType|Status2CN}}）
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="留存收益率：">
                                        {{item.dfi__interestRate}}% （{{item.dfi__interestType|Status2CN}}）
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="贷款合同月利率：">
                                        {{item.monthRate}}‰
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="还款期数（月）：">
                                        {{item.fi__repaymentCount}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="还款方式：">
                                        {{item.fi__repaymentFormula|Status2CN}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="贷款用途：" >
                                        {{item.fi__intendedUse}}
                                    </el-form-item>
                                </el-col>



                            </panel>
                        </el-row>
                    </el-form>
                </panel>
                <panel title="盖章文件">
                    <el-row class="xzpadd10 bg-purple">
                        <data-table
                            :tableData="item.fileData"
                            :columns="filecolumns"
                            :is-pagination-show="false"
                        ></data-table>
                    </el-row>
                    <files-data-table :files="item.fileList"  :additional-columns="additionalColumns" ></files-data-table>
                </panel>
            </panel>
            <panel label="">
                <el-row>
                    <el-col class="grid-content bg-purple">
                        <el-tabs v-model="tabName">
                            <template>
                                <el-tab-pane label="审核流程" name="tabName1">
                                    <data-table
                                        :table-data="{data: dataForm.approvals||[]}"
                                        :columns="approvalTableColumns"
                                        :is-pagination-show="false"
                                    />
                                </el-tab-pane>
                                <el-tab-pane label="流程图" name="tabName2" v-if="dataForm.t__applicationTypeCode=='CY'">
                                    <img
                                        src="../../assets/images/CY.png"  style="width: 100%"></img>
                                </el-tab-pane>
                                <el-tab-pane label="流程图" name="tabName2" v-if="dataForm.t__applicationTypeCode=='SS'">
                                    <img
                                        src="../../assets/images/SS.png"  style="width: 100%"></img>
                                </el-tab-pane>
                                <el-tab-pane label="流程图" name="tabName2" v-if="dataForm.t__applicationTypeCode=='QY'">
                                    <img
                                        src="../../assets/images/QY.png"  style="width: 100%"></img>
                                </el-tab-pane>
                            </template>
                        </el-tabs>
                    </el-col>
                </el-row>
            </panel>

        </panel>
        <div class="tr xzmt">
            <el-button @click="$router.back()">返回</el-button>
        </div>
        <el-dialog title="选择"
                   :visible.sync="dialogVisible" @close="dataRelaod()">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import Status2CN from "../../filters/Status2CN";
    import moment from 'moment'
    import Panel from "../../components/Panel";
    import {formatMoney} from "../../filters/CommonFilters";
    import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "ApproveContractSealProcess",
        data(){
            return {
                filecolumns:[
                    {
                        label:'文件名称',
                        field:'fileName',
                    },
                    {
                        label: '盖章份数',
                        field: 'copies',
                    },
                    {
                        label:'操作',
                        opts: [
                            {
                                label: '下载',
                                class: 'el-icon-download',
                                clickHandler: (index, row, data) => {
                                    //alert(row.fileURL.substr(8,row.fileURL.length-1))
                                    if(row.fileURL.substr(0,6)=='static'){
                                        window.open(row.fileURL)
                                    }else{
                                        window.open(row.fileURL.substr(8,row.fileURL.length-1))
                                    }


                                }

                            }
                        ]

                    }
                ],
                applicationId: this.$route.query['applicationId']||'',
                tabName:'tabName1',
                bankFormFiles: [],
                dataFormRules: {},
                dialogVisible:false,
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions:[],
                filters: {
                    labelWidth: '150px',
                    form: {
                        fi__transactionNo:'',
                        fi__customerName:'',
                        /* c__customerContactNo:'',
                         d__dealerId:'',
                         fi__transactionDate:[],
                         fi__transactionStatus:'',
                         fi__repaymentFormula:'',
                         overdue:'',*/
                    },
                    columns: [
                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 'fi__transactionNo',

                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'fi__customerName',
                            span:12

                        },


                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                },
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName'
                    },
                    {
                        label: '操作',
                        opts:[

                            {
                                class: 'el-icon-check',
                                name: '选择',
                                clickHandler: (index, row)=>{
                                    if(this.selectKeys>-1){
                                        let item = this.dataForm.detail[this.selectKeys]
                                        item.fi__transactionNo = row.fi__transactionNo
                                        item.fi__transactionStatus = row.fi__transactionStatus
                                        item.fi__customerName = row.fi__customerName
                                        item.d__dealerName = row.d__dealerName
                                        item.fi__totalAmount = row.fi__totalAmount
                                        item.ct__productName = row.ct__productName
                                        item.fi__startDate = row.fi__startDate
                                        item.fi__endDate = row.fi__endDate
                                        item.fi__interestRate = row.fi__interestRate
                                        item.fi__interestType = row.fi__interestType
                                        item.dfi__interestType = row.dfi__interestType
                                        item.dfi__interestRate = row.dfi__interestRate
                                        if(row.ct__interestType == 'Yearly'){
                                            item.monthRate = (row.fi__interestRate/12)
                                        }
                                        if(row.ct__interestType == 'Monthly'){
                                            item.monthRate = row.fi__interestRate
                                        }if(row.ct__interestType == 'Daily'){
                                            item.monthRate = (row.fi__interestRate*30)
                                        }

                                        item.monthRate = parseFloat((parseFloat(item.monthRate)*10).toFixed(3))

                                        item.fi__repaymentCount = row.fi__repaymentCount
                                        item.fi__repaymentFormula = row.fi__repaymentFormula
                                        item.fi__intendedUse = row.fi__intendedUse
                                        item.de__referenceId = row.fi__transactionId
                                        item.de__checked = true
                                        this.dialogVisible = false
                                    }

                                }
                            }
                        ]
                    }
                ],
                additionalColumns: [
                    {
                        label: '盖章份数',
                        field: 'copies',
                        formatter: function (r,c,v) {
                            if(v)
                                return v
                            else
                                return 0
                        }
                    }
                ],
                selectKeys:-1,
                dataFormTemp: {
                    t__companySeal:'N',
                    t__legalRepSeal:'N',
                    checkList:['N','N'],
                    detail:[{
                        fileList: [],
                    }]
                },
                approvalTableColumns: [
                    {
                        label: '节点',
                        field: 'a__nodeName',
                        formatter: (r,c,v)=> {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '操作人',
                        field: 'a__approverName'
                    },
                    {
                        label: '操作时间',
                        field: 'a__approvingDate',
                        formatter: (r,c,v)=>{
                            if(v)
                                return moment(v).format('YYYY-MM-DD HH:mm:ss')
                            else
                                return ''
                        }
                    },
                    {
                        label: '操作结果',
                        field: 'a__approvingStatus',
                        formatter: (r,c,v)=> {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '操作备注',
                        field: 'a__remarks'
                    }
                ]
            }
        },
        filters: {

            Status2CN
        },
        computed:{

            dataForm(){
                return this.dataFormTemp
            },
            filterParams: {
                get: function() {
                    return {
                        pageSize: this.pageSize,
                        pageOffset: (this.page - 1) * this.pageSize,
                        'xlist.search.fi.transactionStatus' : 'Processing,Ready,Settled',
                        'xlist.search.fi.transactionStatus.op' : 'in',
                        'xlist.sort.dataField': 'fi.startDate',
                        'xlist.sort.order': 'desc'
                    }
                },
                set:function (newVal) {

                }
            }
        },
        mounted() {
            if(this.applicationId){
                this.getData2()
            }
        },
        methods: {
            getData2:function(){
                xhr.getViewSealApplication({
                        't.applicationId': this.applicationId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.dataFormTemp = res.data.data
                                this.dataFormTemp.detail.forEach((item, idx)=>{
                                    xhr.getFinancingFangSelect(
                                        Object.assign({
                                            'xlist.search.fi.transactionId' : item.de__referenceId,
                                            'xlist.search.fi.transactionId.op' : 'in',
                                        }, {},{}),
                                        res1 => {
                                            try {
                                                let row = res1.data.data[0]
                                                item.fi__transactionNo = row.fi__transactionNo
                                                item.fi__transactionStatus = row.fi__transactionStatus
                                                item.fi__customerName = row.fi__customerName
                                                item.d__dealerName = row.d__dealerName
                                                item.fi__totalAmount = row.fi__totalAmount
                                                item.ct__productName = row.ct__productName
                                                item.fi__startDate = row.fi__startDate
                                                item.fi__endDate = row.fi__endDate
                                                item.fi__interestRate = row.fi__interestRate
                                                item.fi__interestType = row.fi__interestType
                                                item.dfi__interestType = row.dfi__interestType
                                                item.dfi__interestRate = row.dfi__interestRate
                                                if(row.ct__interestType == 'Yearly'){
                                                    item.monthRate = (row.fi__interestRate/12)
                                                }
                                                if(row.ct__interestType == 'Monthly'){
                                                    item.monthRate = row.fi__interestRate
                                                }if(row.ct__interestType == 'Daily'){
                                                    item.monthRate = (row.fi__interestRate*30)
                                                }

                                                item.monthRate = parseFloat((parseFloat(item.monthRate)*10).toFixed(3))

                                                item.fi__repaymentCount = row.fi__repaymentCount
                                                item.fi__repaymentFormula = row.fi__repaymentFormula
                                                item.fi__intendedUse = row.fi__intendedUse
                                                item.de__referenceId = row.fi__transactionId

                                                this.$set(this.dataFormTemp.detail, idx, item)
                                                item.fileList=[]
                                                item.fileData={
                                                    data:[]
                                                }
                                                item.de__docs.forEach(items=>{
                                                    if(items.fileURL.substr(0,6)=='report'||items.fileURL.substr(0,6)=='static'){
                                                        item.fileData.data.push({
                                                            'fileName':items.fileName,
                                                            'copies':items.copies,
                                                            'fileURL':items.fileURL,
                                                        })
                                                    }else{
                                                        item.fileList.push({
                                                            'name':items.fileName,
                                                            'size':items.fileSize,
                                                            'fileId':items.fileURL,
                                                            'copies':items.copies,
                                                        })
                                                    }

                                                })

                                                this.$set(this.dataFormTemp.detail, idx, item)
                                            } catch (e) {

                                            }
                                        })

                                })
                                this.dataFormTemp.approvalArry = []
                                this.dataFormTemp.approvalArry.push(
                                    {
                                        a__nodeName: '项目申请人',
                                        a__approverName: this.dataFormTemp.u__userName,
                                        a__approvingDate: this.dataFormTemp.t__createdDate,
                                        a__approvingStatus: '提交成功',
                                        a__remarks: '',

                                    }
                                )
                                this.dataFormTemp.approvals.filter(items=>items.a__approvalType).forEach(item=>{
                                    this.dataFormTemp.approvalArry.push(
                                        {
                                            a__nodeName: item.a__nodeName,
                                            a__approverName: item.a__approverName,
                                            a__approvingDate: item.a__approvingDate,
                                            a__approvingStatus: Status2CN(item.a__approvingStatus),
                                            a__remarks: item.a__remarks,

                                        }
                                    )
                                })
                                this.dataFormTemp.approvals = this.dataFormTemp.approvalArry
                            }
                        }catch (e) {

                        }
                    })
            },
            Status2CN,



            getData: function () {
                xhr.getFinancingFangSelect(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res => {
                        try {
                            this.tableData = res.data
                        } catch (e) {

                        }
                    })
            },
            onSubmit :function (status) {
                this.dataForm.a__approvingStatus = status
                xhr.ApproveSealApplication(
                    this.dataForm,
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.$router.push({
                                    name: 'ContractSealProcessListView'
                                })
                            }else{
                                this.$message.error(res.data.msgs[0].text)
                            }

                        }catch (e) {

                            this.$message.error(error.msgs[0].text)

                        }
                    }
                )
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApproveContractSealProcessView.vue